import RoleTenure from './RoleTenure';

export default RoleTenure;
